import React from "react";
import Container from "react-bootstrap/Container";
import { Card, CardColumns, Button, Modal } from "react-bootstrap";
import CarouselRemo from "./CarouselRemo";
import BannerTitles from "./BannerTitles";

let animationArray = ["cardMoveInTop", "cardMoveInBottom", "cardMoveInLeft", "cardMoveInRight"];

let remodels = [
	{
		name: "Laidley Street, San Francisco, CA",
		images: ["Laidley Street, San Francisco, CA1.jpg-Laidley Street, San Francisco, CA2.jpg-Laidley Street, San Francisco, CA3.jpg-Laidley Street, San Francisco, CA4.jpg-Laidley Street, San Francisco, CA5.jpg-Laidley Street, San Francisco, CA6.jpg-Laidley Street, San Francisco, CA7.jpg-Laidley Street, San Francisco, CA8.jpg-Laidley Street, San Francisco, CA9.jpg-Laidley Street, San Francisco, CA10.jpg"],
		award: "2018 Remodel of the Year"
	},

	{
		name: "Santa Rosa Avenue, Santa Barbara, CA",
		images: ["Santa Rosa Avenue, Santa Barbara, CA1.jpg-Santa Rosa Avenue, Santa Barbara, CA2.jpg-Santa Rosa Avenue, Santa Barbara, CA3.jpg-Santa Rosa Avenue, Santa Barbara, CA4.jpg-Santa Rosa Avenue, Santa Barbara, CA5.jpg-Santa Rosa Avenue, Santa Barbara, CA6.jpg"]
	},
	{
		name: "Bayswater Ave Burlingame, CA",
		images: ["Bayswater Ave Burlingame, CA1.jpg-Bayswater Ave Burlingame, CA2.jpg-Bayswater Ave Burlingame, CA3.jpg-Bayswater Ave Burlingame, CA4.jpg"]
	},
	{
		name: "Chelmsford Rd, Hillsborough, CA",
		images: ["Chelmsford Rd, Hillsborough, CA1.jpg-Chelmsford Rd, Hillsborough, CA2.jpg"]
	},
	{
		name: "Highland Ave San Carlos, CA",
		images: ["Highland Ave San Carlos, CA1.jpg-Highland Ave San Carlos, CA2.jpg-Highland Ave San Carlos, CA3.jpg-Highland Ave San Carlos, CA4.jpg-Highland Ave San Carlos, CA5.jpg-Highland Ave San Carlos, CA6.jpg-Highland Ave San Carlos, CA7.jpg-Highland Ave San Carlos, CA8.jpg-Highland Ave San Carlos, CA9.jpg-Highland Ave San Carlos, CA10.jpg-Highland Ave San Carlos, CA11.jpg"]
	},
	{
		name: "Jackson St, San Francisco, CA",
		images: ["Jackson St, San Francisco, CA1.jpg-Jackson St, San Francisco, CA2.jpg-Jackson St, San Francisco, CA3.jpg-Jackson St, San Francisco, CA4.jpg-Jackson St, San Francisco, CA5.jpg"]
	},
	{
		name: "Mallorca Way, San Francisco, CA",
		images: ["Mallorca Way, San Francisco, CA1.jpg"]
	},
	{
		name: "Matheson Street, Healdsburg, CA",
		images: ["Matheson Street, Healdsburg, CA1.jpg-Matheson Street, Healdsburg, CA2.jpg-Matheson Street, Healdsburg, CA3.jpg-Matheson Street, Healdsburg, CA4.jpg-Matheson Street, Healdsburg, CA5.jpg-Matheson Street, Healdsburg, CA6.jpg"]
	},
	{
		name: "Ramona Avenue, Albany, CA",
		images: ["Ramona Avenue, Albany, CA1.jpg-Ramona Avenue, Albany, CA2.jpg-Ramona Avenue, Albany, CA3.jpg-Ramona Avenue, Albany, CA4.jpg-Ramona Avenue, Albany, CA5.jpg-Ramona Avenue, Albany, CA6.jpg"]
	},
	{
		name: "Rosewood Drive, San Francisco, CA",
		images: ["Rosewood Drive, San Francisco, CA1.jpg-Rosewood Drive, San Francisco, CA2.jpg-Rosewood Drive, San Francisco, CA3.jpg"]
	},
	{
	name: "Iris Street, San Francisco, CA",
	images: ["Iris Street, San Francisco, CA1.jpg-Iris Street, San Francisco, CA2.jpg-Iris Street, San Francisco, CA3.jpg-Iris Street, San Francisco, CA4.jpg-Iris Street, San Francisco, CA5.jpg-Iris Street, San Francisco, CA6.jpg-Iris Street, San Francisco, CA7.jpg-Iris Street, San Francisco, CA8.jpg-Iris Street, San Francisco, CA9.jpg-Iris Street, San Francisco, CA10.jpg-Iris Street, San Francisco, CA11.jpg-Iris Street, San Francisco, CA12.jpg-Iris Street, San Francisco, CA13.jpg-Iris Street, San Francisco, CA14.jpg-Iris Street, San Francisco, CA15.jpg-Iris Street, San Francisco, CA16.jpg-Iris Street, San Francisco, CA17.jpg-Iris Street, San Francisco, CA18.jpg-Iris Street, San Francisco, CA19.jpg-Iris Street, San Francisco, CA20.jpg"]
	}
];
let imgPath2 = require.context("../../public/images/remodels", true);

const titleMap = {
	"Bayswater Ave Burlingame, CA": "Bayswater Avenue Residence",
	"Chelmsford Rd, Hillsborough, CA": "Chelmsford Road Residence",
	"Highland Ave San Carlos, CA": "Highland Avenue Residence",
	"Jackson St, San Francisco, CA": "Jackson Street Residence",
	"Mallorca Way, San Francisco, CA": "Mallorca Way Residence",
	"Matheson Street, Healdsburg, CA": "Matheson Street Residence",
	"Ramona Avenue, Albany, CA": "Ramona Avenue Residence",
	"Rosewood Drive, San Francisco, CA": "Rosewood Drive Residence",
	"Iris Street, San Francisco, CA": "Iris Street Residence",
	"Laidley Street, San Francisco, CA": "Laidley Cottage",
	"Santa Rosa Avenue, Santa Barbara, CA": "Santa Rosa Avenue Residence",
};

const locationMap = {
	"Bayswater Ave Burlingame, CA": "Burlingame, CA",
	"Chelmsford Rd, Hillsborough, CA": "Hillsborough, CA",
	"Highland Ave San Carlos, CA": "San Carlos, CA",
	"Jackson St, San Francisco, CA": "San Francisco, CA",
	"Mallorca Way, San Francisco, CA": "San Francisco, CA",
	"Matheson Street, Healdsburg, CA": "Healdsburg, CA",
	"Ramona Avenue, Albany, CA": "Albany, CA",
	"Rosewood Drive, San Francisco, CA": "San Francisco, CA",
	"Iris Street, San Francisco, CA": "Burlingame, CA",
	"Laidley Street, San Francisco, CA": "San Francisco, CA",
	"Santa Rosa Avenue, Santa Barbara, CA": "Santa Barbara, CA"
};

const getLocation = name => locationMap[name] || name;
const getProjectTitle = name => titleMap[name] || name;
const getProjectCategory = name => "Remodeling & Addition";

const Remodels = props => {
	return (
		<Container fluid className="p-0">
			<BannerTitles title={"Remodeling & Additions"} />
			<Container className="col-12 col-md-9">
				<CardColumns>
					{remodels.map((build, idx) => {
						let time = Math.random() * 4;
						let num = Math.floor(Math.random() * Math.floor(4));
						let name = animationArray[num];
						let imgStyle = { animation: `${name} ${time}s` };
						let imgSrc = imgPath2("./" + `${build.name}` + "1.jpg");

						return (
							<Card className="gallery-card" style={imgStyle} key={idx}>
								<Card.Img src={imgSrc}></Card.Img>
								<Card.ImgOverlay className="gallery-overlay">
									<Button onClick={props.handleClick} value={build.name} name={build.images} className="gallery-view-button">
										View
									</Button>
								</Card.ImgOverlay>
								<Card.Body>
									<Card.Title>{getProjectTitle(build.name)}</Card.Title>
									<Card.Text>{getProjectCategory(build.name)} | {getLocation(build.name)}</Card.Text>
									{build.award && <Card.Text className="project-award">{build.award}</Card.Text>}
								</Card.Body>
							</Card>
						);
					})}
				</CardColumns>

				<Modal show={props.show} onHide={props.closeModal} container={this} dialogClassName="modal-90w" aria-labelledby="contained-modal-title">
					<Modal.Header closeButton className="lightbox-header" />
					<Modal.Body className="mx-auto" style={{ width: "100%" }}>
						<CarouselRemo images={props.imgs} />
					</Modal.Body>
				</Modal>

				<hr className="my-5" />
			</Container>
		</Container>
	);
};
export default Remodels;
